export default __webpack_public_path__ + "static/media/landscape2-Mask-industrialfix.40239bb5.png";